/**
 * Raportti → Tila: the report's material beyond what this page makes —
 * transcripts, Mitä jos? texts, the executive summary — each
 * with its status, and the exact script where there is no UI yet. The same
 * items as Yleiskuva's Tulokset card (utils/stageStatus.js).
 */
import React from 'react';
import useInstanceRecord from '../../hooks/useInstanceRecord';
import useInstanceOverview from '../../hooks/useInstanceOverview';
import { buildStageStatus } from '../../utils/stageStatus';
import { useTranslation } from '../../hooks/useTranslation.jsx';
import { ChecklistItem, Items } from '../../screens/AdminHome/StageCard';
import { SectionLabel, StatusMessage } from './reportAdminStyles';

// Translations are listed by the translate panel above, so not repeated here.
const SHOWN = ['transcripts', 'whatif', 'summary'];

export default function ReportStatusPanel({ instanceId }) {
  const { t } = useTranslation();
  const { instance } = useInstanceRecord(instanceId);
  const { overview, error } = useInstanceOverview(instanceId);

  if (error) return <StatusMessage $error>{t('settingsPages.loadFailed', { error })}</StatusMessage>;
  if (!instance || !overview) return null;

  const items = buildStageStatus({ instance, overview }).stages.results.items.filter((i) => SHOWN.includes(i.key));
  return (
    <div style={{ marginBottom: 40 }}>
      <SectionLabel>{t('reportStatus.title')}</SectionLabel>
      <Items>
        {items.map((item) => <ChecklistItem key={item.key} item={item} instanceId={instanceId} />)}
      </Items>
    </div>
  );
}
